import { useState } from 'react';
import './Faq.css';
import { Helmet } from 'react-helmet';


const FAQSection = () => {
  // State to track which sections are expanded
  const [expandedSections, setExpandedSections] = useState({
    sustainability: false,
    aboutUs: false,
    returns: false,
    help: false
  });

  // State to track which questions are expanded within each section
  const [expandedQuestions, setExpandedQuestions] = useState({});

  // Toggle section expansion
  const toggleSection = (section) => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section]
    });
  };

  // Toggle question expansion
  const toggleQuestion = (questionId) => {
    setExpandedQuestions({
      ...expandedQuestions,
      [questionId]: !expandedQuestions[questionId]
    });
  };

  // FAQ Data structure
  const faqData = [
    {
      id: 'sustainability',
      title: 'Sustainability and Ethical Production',
      questions: [
        {
          id: 'greenwashing',
          question: 'How do you verify no greenwashing?',
          answer: 'We have a few big criteria that we follow for ensuring businesses are transparent, but we work with various nonprofits and clubs at the UW to ensure that businesses are being true to their mission!'
        }
      ]
    },
    {
      id: 'aboutUs',
      title: 'About Us',
      questions: [
        {
          id: 'difference',
          question: 'What makes Verdure Different?',
          answer: 'Verdure focuses on bringing products that are more relevant to younger audiences in one convenient platform. These products are both verified to be sustainable/ethically produced, however, we try to curate ones that are more affordable as well. As college students, we want to make this something youth throughout can use!'
        },
        {
          id: 'affordability',
          question: 'What do you mean by affordability?',
          answer: 'Affordability is very subjective, and that is why we have businesses put a price range when they onboard onto our platform. You will be able to see this price range, but we have almost every product under $100. We aim to have more comparable prices to larger retailers, however, because these products are ethically manufactured, they tend to be a bit more expensive.'
        }
      ]
    },
    {
      id: 'returns',
      title: 'Returns and Cancelations',
      questions: [
        {
          id: 'returnPolicy',
          question: 'Do you have a return or cancelation policy?',
          answer: 'Our platform does not directly support cancellations, returns, or refunds. We are currently working on a system where businesses can set if they\'d like to have a product canceled or returned/refunded. For right now, if you want to return / cancel a product, please email yourverdure@gmail.com with your Order ID. We will work with the business and get back to you on this - returns/cancelations will be treated on a case by case basis.'
        }
      ]
    },
    {
      id: 'help',
      title: 'I want to help!',
      questions: [
        {
            id: 'payment',
            question: 'How does payments work?',
            answer: 'Verdure utilizes Stripe for payments. After adding to your cart and viewing your subtotal, you will be taken to Stripe for checkout. Note, you must be logged in to add to cart and checkout. We recommend saving the Stripe Link so payment goes by faster!'
          },
        {
          id: 'joining',
          question: 'Interested in joining our team? Partnering with us?',
          answer: 'Please email yourverdure@gmail.com with your proposal.'
        }
      ]
    }
  ];

  return (
    <div className="faq-container">

<Helmet>
  <title>FAQs | Verdure</title>
  <meta name="description" content="Got questions about sustainable shopping, how Verdure works, or how we vet brands? We’ve got answers." />
  <meta property="og:title" content="FAQs | Verdure" />
  <meta property="og:description" content="Answers to common questions about Verdure’s mission, products, and process." />
</Helmet>

      <h2 className="faq-main-title">Frequently Asked Questions</h2>
      
      {faqData.map((section) => (
        <div key={section.id} className="faq-section">
          <div 
            className={`faq-section-header ${expandedSections[section.id] ? 'active' : ''}`}
            onClick={() => toggleSection(section.id)}
          >
            <h3>{section.title}</h3>
            <span className="faq-toggle-icon">
              {expandedSections[section.id] ? '−' : '+'}
            </span>
          </div>
          
          {expandedSections[section.id] && (
            <div className="faq-section-content">
              {section.questions.map((item) => (
                <div key={item.id} className="faq-item">
                  <div 
                    className={`faq-question ${expandedQuestions[item.id] ? 'active' : ''}`}
                    onClick={() => toggleQuestion(item.id)}
                  >
                    <h4>{item.question}</h4>
                    <span className="faq-toggle-icon question-toggle">
                      {expandedQuestions[item.id] ? '−' : '+'}
                    </span>
                  </div>
                  
                  {expandedQuestions[item.id] && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQSection;